import { Routes } from '@angular/router';
import { ContainerComponent } from './home/pages/container/container.component';
import { PublicGuard } from './guards/public.guard';
import { projectRoutes } from './project-management/project-management.routes';
import { privateChildGuard, privateGuard } from './guards/private.guard';
import { authRoutes } from './auth/auth.routes';
import { reportsRoutes } from './reports/reports.routes';
import { taskRoutes } from './task/task.routes';
import { redcamRoutes } from './redcam/redcam.routes';
import { sucursalRoutes } from './sucursal/sucursal.routes';
import { costosRoutes } from './centro-costos/centro-costos.routes';
import { tarjetaDigitalRoutes } from './tarjeta-digital/tarjeta-digital.routes';
import { communiqueRoutes } from './communique/communique.routes';

export const routes: Routes = [
	{
		path: 'auth',
		canActivate: [PublicGuard],
		children: authRoutes,
	},
	{
		path: 'admin',
		component: ContainerComponent,
		canActivate: [privateGuard],
		canActivateChild: [privateChildGuard],
		children: [
			{
				path: 'home',
				loadChildren: () =>
					import('./home/home.module').then((m) => m.HomeModule),
			},
			{
				path: 'project-management',
				children: projectRoutes,
			},
			{
				path: 'editor',
				loadChildren: () =>
					import('./editor/editor.module').then((m) => m.EditorModule),
			},
			{
				path: 'task',
				children: taskRoutes,
			},
			{
				path: 'communique',
				children: communiqueRoutes
			},
			{
				path: 'sales',
				loadChildren: () =>
					import('./sales-v3/sales-v3.module').then((s) => s.SalesV3Module),
			},
			{
				path: 'mission',
				loadChildren: () =>
					import('./missions-v2/missions-v2.module').then(
						(m) => m.MissionsV2Module
					),
			},
			{
				path: 'payment',
				loadChildren: () =>
					import('./payments/payments.module').then((m) => m.PaymentsModule),
			},
			{
				path: 'disperse-reconcile',
				loadChildren: () =>
					import('./disperse-reconcile/disperse-reconcile.module').then(
						(m) => m.DisperseReconcileModule
					),
			},
			{
				path: 'reports',
				children: reportsRoutes,
			},
			{
				path: 'users',
				loadChildren: () =>
					import('./users/users.module').then((m) => m.UsersModule),
			},
			{
				path: 'sections',
				loadChildren: () =>
					import('./sections/sections.module').then((m) => m.SectionsModule),
			},
			{
				path: 'retention',
				loadChildren: () =>
					import('./retention/retention.module').then((m) => m.RetentionModule),
			},
			{
				path: 'check-in',
				loadChildren: () =>
					import('./check-in/check-in.module').then((m) => m.CheckInModule),
			},
			{
				path: 'settings',
				loadChildren: () =>
					import('./settings/settings.module').then((m) => m.SettingsModule),
			},
			{
				path: 'course',
				loadChildren: () =>
					import('./course/course.module').then((m) => m.CourseModule),
			},
			{
				path: 'notification',
				loadChildren: () =>
					import('./notification/notification.module').then(
						(m) => m.NotificationModule
					),
			},
			{
				path: 'integration',
				loadChildren: () =>
					import('./integration/integration.module').then(
						(m) => m.IntegrationModule
					),
			},
			{
				path: 'supervision-relationship',
				loadChildren: () =>
					import(
						'./supervision-relationship/supervision-relationship.module'
					).then((m) => m.SupervisionRelationshipModule),
			},
			{
				path: 'visor',
				loadChildren: () =>
					import('./visor/visor.module').then((m) => m.VisorModule),
			},
			{
        path: 'redcam',
        children: redcamRoutes,
      },
			{
				path: 'sucursales',
				children: sucursalRoutes
			},
			{
        path: 'redcam',
        children: redcamRoutes,
      },
			{
				path: 'costos',
        children: costosRoutes
			},
			{
				path: 'tarjeta',
				children: tarjetaDigitalRoutes,
			},
			{
				path: 'nube',
				loadChildren: () => import('./nube/nube.routes').then((m) => m.nubeRoutes),
			},
			{ path: '**', redirectTo: 'home', pathMatch: 'full' },
		],
	},
	{ path: '**', redirectTo: 'auth', pathMatch: 'full' },
];
